var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.594 16.406L10.5 10.5m0 0L4.594 4.594M10.5 10.5l5.906 5.906M10.5 10.5l5.906-5.906",
    stroke: "#7D8085",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuNTkzNzUgMTYuNDA2MkwxMC41IDEwLjVNMTAuNSAxMC41TDQuNTkzNzUgNC41OTM3NU0xMC41IDEwLjVMMTYuNDA2MiAxNi40MDYyTTEwLjUgMTAuNUwxNi40MDYyIDQuNTkzNzUiIHN0cm9rZT0iIzdEODA4NSIgc3Ryb2tlLXdpZHRoPSIxLjIiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgModalClose as ReactComponent };